var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPending(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.346 -1.018) scale(1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.08333C2.75 6.39298 3.30964 5.83333 4 5.83333H12.2861C12.6247 5.83333 12.9466 5.9807 13.1679 6.23695L15.7818 9.26362C16.1554 9.69615 16.1554 10.3372 15.7818 10.7697L13.1679 13.7964C12.9466 14.0526 12.6247 14.2 12.2861 14.2H4C3.30964 14.2 2.75 13.6403 2.75 12.95V7.08333Z",
    stroke: "currentColor",
    strokeWidth: 1.364,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.83333,
    cy: 10.0167,
    r: 0.916667,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.33f69688.svg";
export { ForwardRef as ReactComponent };